var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGiftColored(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 28012"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 9062",
    style: {
      fill: "none"
    },
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "vuesax/linear/card-remove"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h8.625",
    transform: "translate(4.5 9.375)",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px",
      stroke: "#8c8d99",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Vector",
    d: "M0 0h1.5",
    transform: "translate(7.5 15.375)",
    style: {
      stroke: "#1bc47d",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Vector",
    d: "M0 0h3",
    transform: "translate(10.875 15.375)",
    style: {
      stroke: "#1bc47d",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Vector",
    d: "M15 6.4v3.06c0 2.632-.668 3.292-3.33 3.292H3.33C.668 12.75 0 12.09 0 9.458V3.293C0 .66.668 0 3.33 0h5.3",
    transform: "translate(4.5 5.625)",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px",
      stroke: "#8c8d99",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Vector",
    d: "m.426 2.185 1.935 1.7a.241.241 0 0 0 .323 0l1.935-1.7A1.246 1.246 0 0 0 3.051.25l-.525.4-.533-.4A1.243 1.243 0 0 0 .426 2.185z",
    transform: "translate(15.475 5.9)",
    style: {
      stroke: "#1bc47d",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px",
      fill: "none"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftColored);
export default __webpack_public_path__ + "static/media/gift-colored.965eb562447f5f92549a6c6892d588dc.svg";
export { ForwardRef as ReactComponent };